import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import useApp from 'hooks/useApp';
import useApi from 'hooks/useApi';
import { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import helperDialog from 'helpers/helper.dialog';

export default function ResetPassword(props) {
    const app = useApp();
    const api = useApi();
    const { id, tipo, doc } = props; // tipo = 1 = Empresa, 2 = Funcionario
    const [pass, sePass] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);

    const HandleResetPass = (event) => {
        event.preventDefault();

        api.post(`auth/resetpass/${id}/${tipo}`).then(async (response) => {
            if (response.data.success == false) {
                helperDialog.dialog.Info(response.data.xmessage);
                return;
            }
            sePass(response.data.data);
            helperDialog.dialog.Info("Senha Resetada. A senha foi resetada com sucesso. A nova senha é: " + response.data.data);
        });
    };

    return (
        <div className="container mx-auto max-w-sm">
            <div className="card p-4">
                <div className="text-center mb-4">
                    <h2 className="text-2xl font-bold">Reset de Senha</h2>
                </div>
                <form onSubmit={HandleResetPass}>
                    <div className="mb-4 text-center">
                        <label htmlFor="funcionario" className="block text-left">{tipo === '1' ? 'Empresa' : 'Funcionário'}</label>
                        <InputText
                            id="funcionario"
                            value={props.title}
                            className="w-full text-left"
                            readOnly
                            style={{ backgroundColor: 'transparent', border: 'none' }}
                        />
                        <label htmlFor="matricula" className="block text-left">{tipo === '1' ? 'CNPJ' : 'Matricula'}</label>
                        <InputText
                            id="matricula"
                            value={doc}
                            className="w-full text-left"
                            readOnly
                            style={{ backgroundColor: 'transparent', border: 'none' }}
                        />
                        <InputText
                            id="pass"
                            value={pass}
                            className="w-full text-center"
                            readOnly
                        />
                        <label htmlFor="pass" className="block text-left">Click abaixo no Botão Resetar Senha para Gerar a Nova Senha Acima</label>
                    </div>
                    {errorMsg && (
                        <div className="mb-4">
                            <Message severity="error" text={errorMsg} />
                        </div>
                    )}
                    <div className="text-center">
                        <Button type="submit" label="Resetar Senha" className="p-button-rounded p-button-primary" />
                    </div>
                </form>
            </div>
        </div>
    );
}

